import {TreeNode} from "../types/types";

export const findNodeById = (id: string, data: TreeNode[]): TreeNode | undefined => {
    for (const node of data) {
        if (node.value === id) {
            return node;
        }
        if (node.children && node.children.length > 0) {
            const foundNode = findNodeById(id, node.children);
            if (foundNode) return foundNode;
        }
    }
    return undefined;
};


export const findPath = (tree: TreeNode[], targetValue: string, path: string[] = []): string[] | null => {
    for (const node of tree) {
        const newPath = [...path, node.value];
        if (node.value === targetValue) {
            return newPath;
        }
        if (node.children) {
            const childPath = findPath(node.children, targetValue, newPath);
            if (childPath) return childPath;
        }
    }
    return null;
};
